import { Button, FormGroup, Modal } from "react-bootstrap";
import { dateFormatUtcToYMD1 } from "src/utils/dateManagement";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import {
  subscriptionSuspend as inicisSubscriptionsSuspend,
  subscriptionActive as inicisSubscriptionsActivate,
} from "src/service/pay";
import {
  subscriptionsActivate as paypalSubscriptionsActivate,
  subscriptionsSuspend as paypalSubscriptionsSuspend,
} from "src/service/paypal";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import { serviceNoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { useState } from "react";
import { useTranslation } from "react-i18next";
interface ISubscriptionsCancelModalProps {
  props?: any;
}
// 결제 주기 변경 모달
const SubscriptionsCancelModal = ({
  props,
}: // goPrint,
ISubscriptionsCancelModalProps) => {
  const { serviceList: myServiceList } = useGetMyServiceList({});
  const [subscriptionId, setSubscriptionId] = useState<string>("");
  const [serviceNo] = useRecoilState(serviceNoAtom);
  const { payInfoModalState, togglePayInfoModal } = useBillStatement();
  const { t } = useTranslation();
  // 구독 종료
  const subscriptionsSuspend = async (e: any) => {
    // this.commonStore.setLoading(true)
    e.preventDefault();

    const subscriptionsSuspendReq = {
      reason: "Suspend subscription",
    };

    if (myServiceList) {
      if (myServiceList[serviceNo]?.payCompany === "PAYPAL") {
        const result = await paypalSubscriptionsSuspend({
          subscriptionId,
          subscriptionsSuspendReq,
        }).then(() => {
          window.location.reload();
        });
      } else {
        const result = await inicisSubscriptionsSuspend({
          product: getProductFromSessionStorage(),
          another: "SUSPENDED",
        }).then(() => {
          window.location.reload();
        });
      }
    }
  };
  return (
    <>
      <Modal
        show={payInfoModalState?.subscriptionsCancel}
        onHide={() => togglePayInfoModal({ info: "subscriptionCancel" })}
        className="confirm__period"
        style={{ opacity: 1 }}
      >
        <Modal.Header>
          <Modal.Title>
            {t("siteManagement.notice.cancleSubscription1")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup className="mg mb-0">
            {t("siteManagement.notice.cancleSubscription2", {
              0: dateFormatUtcToYMD1(
                myServiceList[serviceNo]?.nextPayDate.toString()
              ),
            })}
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-gray"
            onClick={() => togglePayInfoModal({ info: "subscriptionCancel" })}
          >
            {t("common.cancelBtn")}
          </Button>
          <Button className="btn btn-green" onClick={subscriptionsSuspend}>
            {t("common.okBtn")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SubscriptionsCancelModal;
